import { render, staticRenderFns } from "./facebookLogin.vue?vue&type=template&id=85fe558c&"
import script from "./facebookLogin.vue?vue&type=script&lang=js&"
export * from "./facebookLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports